import { FileType } from "@/enums/FileType";

export const FileIcons = {
  [FileType.Binary]: "fa-file",
  [FileType.Image]: "fa-image",
  [FileType.Text]: "fa-file-alt"
};
